import styled from "@emotion/styled";
import { useSystemAlertState } from "@/store";
import { ExclamationCircleIcon } from "@/icons";

export const SystemAlertBar = () => {
    const { message } = useSystemAlertState();
    const hasContent = (message || "").trim().length > 0;

    return (
        <Banner
            isVisible={hasContent}
            role={hasContent ? "status" : undefined}
            aria-live={hasContent ? "polite" : undefined}
            aria-hidden={!hasContent}
        >
            <Inner>
                <IconWrap aria-hidden="true">
                    <ExclamationCircleIcon />
                </IconWrap>
                <Message>{message}</Message>
            </Inner>
        </Banner>
    );
};

const Banner = styled.div`
    width: 100%;
    max-height: ${({ isVisible }) => (isVisible ? "40vh" : "0")};
    padding: ${({ isVisible }) => (isVisible ? "10px 16px" : "0 16px")};
    box-sizing: border-box;

    background-color: #F7F19A;
    color: #1B2432;
    
    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
    ${({ isVisible }) => (isVisible ? "overflow-y: auto;" : "")}

    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transform: translateY(${({ isVisible }) => (isVisible ? "0" : "-8px")});
    transition: opacity 200ms ease, transform 200ms ease, max-height 200ms ease,
    padding 200ms ease;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: ${({ isVisible }) => (isVisible ? "8px 12px" : "0 12px")};
    }
`;

const Inner = styled.div`
    width: min(1200px, 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
`;

const IconWrap = styled.div`
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    color: #1B2432;

    & > svg {
        width: 22px;
        height: 22px;
        display: block;
    }
`;

const Message = styled.div`
  font-size: 16px;
  text-align: center;

  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
    font-weight: 700;
  }
`;